import dynamicRepo from '@/repository/dynamicRepo'
import serviceRepo from '@/repository/service.repo'
import type { ClassT } from '@/types'

// TODO: useDynamicRepo 형식에 맞추고 기존에 param 넘겨서 쓰고 있던 것들은 각자 알아서 memo해서 쓰도록...
const useRepository = <T extends ClassT>(
  identifier: [service: T, key: string] | T,
  ...param: ConstructorParameters<T>
) => {
  if (Array.isArray(identifier)) {
    return dynamicRepo.reg(identifier, ...param)
  }
  return serviceRepo.reg(identifier, ...param)
}

export default useRepository
